document.addEventListener("DOMContentLoaded", (event) => {
  //footer accordion 
  var acc = document.getElementsByClassName("menu-click");
    
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
  
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
       
  //mobile account navigation accordion 
  var mobAcc = document.getElementsByClassName("mobile_account_header");
  if(mobAcc.length > 0){
    mobAcc[0].addEventListener("click", function() {
      this.classList.toggle("active");
    
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
    
  // Wishlist: Replace 'Add to cart' button to 'Instore Only' when the product is instore only product.
  if (window.location.href.includes('wishlist')) { checkInstoreProduct(); }

   // Send GTM when user login -> redirected to the account Login first time.
  if(window.location.pathname == '/account' && localStorage.getItem('user_login') && customer_email){
    console.log('* Send events: user_login')
    localStorage.removeItem('user_login');
    Shopify.analytics.publish('user_login', {email: customer_email });
  }
  // Send GTM when user create account -> redirected to the index page first time.
  if(window.location.pathname == '/' && localStorage.getItem('email_signup') && customer_email){
    console.log('* Send events: email_signup')
    localStorage.removeItem('email_signup');
    Shopify.analytics.publish('email_signup', {email: customer_email });
  }
});

window.addEventListener('load', function() {
  var noodrewards = document.getElementsByClassName("nood-rewards-calc");
  var clickvariant = document.querySelectorAll(".selector-wrapper li a");

  if (noodrewards.length > 0) {
    var i;
    for (i = 0; i < clickvariant.length; i++) {
      clickvariant[i].addEventListener("click", function() {
        console.log('hihi')
        var updateVal = this.getAttribute('data-value');
        var calcVal = ((updateVal.slice(5)) / 10).toFixed(1);

        noodrewards[0].innerHTML = calcVal;
      
      });
    }
  }

});


function openPopup(selector){
  $(selector).addClass('active');
}

function closePopup(selector){
  $(selector).removeClass('active');
}

// Account reward page
function showTab(target, e){
  // btn
  $('#account-reward-tab-btns a').removeClass('active');
  $(e).addClass('active')

  // content
  $('#account-reward-orders>div').removeClass('active')
  $(target).addClass('active');
}

function waitForElm(selector) {
  return new Promise(resolve => {if (document.querySelector(selector)) {return resolve(document.querySelector(selector));}const observer = new MutationObserver(mutations => {if (document.querySelector(selector)) {resolve(document.querySelector(selector));observer.disconnect();}});observer.observe(document.body, {childList: true,subtree: true});});
}

async function getProductDetails(JSONurl){
  try {
    const response = await fetch(JSONurl);
    return await response.json();
  }
  catch (err) {
    console.log('fetch failed', err);
  }
}
function handleAddToCartCollection(event) {
  const $container = $(event.target).closest('.product-block');
  theme.applyAjaxToProductForm($container);
}


window.onload = () => {
  const productSlider = document.querySelector('.template-cart .product-slider');
  
  if (productSlider) {
    // Trigger a reflow to ensure that styles are correctly applied before transitioning
    productSlider.offsetHeight; // This forces a reflow
    
    // Change styles to make it visible with a smooth transition
    productSlider.style.transition = 'opacity 0.3s ease, height 0.3s ease';
    productSlider.style.opacity = '1';
    productSlider.style.height = 'auto'; // Or set to a specific value if needed
  }
};

// Product Page Load More
$('#load-more').on('click', function() {
  const allImages = $('.theme-images .media-column > div, .theme-images .theme-img--collage-last');
  const imagesToHide = $('.theme-images .media-column > div:not(:first-child), .theme-images .theme-img--collage-last');
  const button = $(this);

  if (!button.hasClass('active')) {
      button.addClass('active');
      button.text('Show Less');
      allImages.show();
  } else {
      button.removeClass('active');
      button.text('Show More');
      imagesToHide.hide();
      document.querySelector('.product-media').scrollIntoView({ 
          behavior: 'smooth', 
          block: 'end' 
      });
  }
});
$(document).ready(function() {
  const rflctBlock = $('.rflct-block');
  const noodPoints = $('.product-nood-points');
  if (window.innerWidth < 768) {
      rflctBlock.insertBefore(noodPoints);
  } 
});
// Product Page Load More